/* eslint-disable no-unused-vars */
/* eslint-disable no-irregular-whitespace */
/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import AppNumberInput from '../../shared/components/app-number-input/AppNumberInput';
import {
  checkValidMobileNumber,
  DATE_MONTH_YEAR_VIEW_FORMAT,
  PREF_CLASS_OPTIONS,
} from '../../shared/constants/Constants';
import AppButton from '../../shared/components/app-button/AppButton';
import RoundTripIntlEmailCard from './RoundTripIntlEmailCard';
import {
  getUserAgentId,
  getValueFromAppConfig,
} from '../../shared/helper-utils/localStorage';
import {
  formatDate,
  formatTimeString,
  getCabinBaggage,
  getConnectingTime,
  getNewDate,
  isEmpty,
} from '../../shared/helper-utils/appUtils';
import AppRadioInput from '../../shared/components/app-radio-input/AppRadioInput';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import { getUserDetails } from '../../api/profileApi';
import { useAppContext } from '../../saas/AppConfigWrapper';
import AppTextInput from '../../shared/components/app-text-input/AppTextInput';

import AppSelect from '../../shared/components/app-select/AppSelect';
import { countryMobileCodes } from '../../shared/constants/CountryOptions';

const getLabel = (country) => {
  return (
    <div
      className="flex justify-between items-center gap-2"
      title={country.name}
    >
      <div className="flex items-center gap-1 w-[78%]">
        <img
          style={{ width: '17px', height: '15px', display: 'inline' }}
          src={`https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/${country.code.toLowerCase()}.svg`}
          alt={country.code}
        />
        <span className="text-[12px] overflow-hidden">{country.name}</span>
      </div>
      <div className="flex-shrink-0">
        <span className="text-[12px]">{country.dial_code}</span>
      </div>
    </div>
  );
};

const mobileCodes = countryMobileCodes.map((country) => ({
  label: getLabel(country),
  value: country.dial_code,
}));
function RoundTripIntlWhatsAppModal({
  searchRequest,
  selectedFlights,
  onSend,
}) {
  const { appConfig } = useAppContext();
  const [isLoading, setIsLoading] = useState(false);
  const [whatsappNumber, setWhatsappNumber] = useState('');
  const [validationError, setValidationError] = useState(false);
  const [showBreakup, setShowBreakup] = useState(true);
  const [selectedFares, setSelectedFares] = useState(
    selectedFlights.map((d) => {
      return d.fare.totalfq;
    }),
  );

  const [markUpToBeAdded, setMarkupToBeAdded] = useState('');
  const [countryCode, setCountryCode] = useState(appConfig.appMobileCode);
  const [userDetails, setUserDetails] = useState(null);
  const [countryCodeOptions] = useState(mobileCodes);

  const getAmount = (val) => {
    const markup = markUpToBeAdded === '' ? 0 : parseInt(markUpToBeAdded, 10);
    return parseInt(val, 10) + markup;
  };

  const getUserData = async () => {
    setIsLoading(true);
    const res = await getUserDetails(getUserAgentId());
    if (res?.ApiStatus?.Status === 'OK') {
      const { User } = res.ApiStatus.Result;
      setUserDetails(User);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getUserData();
  }, []);

  const handleSend = () => {
    if (
      whatsappNumber === '' ||
      whatsappNumber === undefined ||
      checkValidMobileNumber(whatsappNumber)
    ) {
      setValidationError(true);
      return false;
    }
    const numberWithCountryCode = (countryCode + whatsappNumber).replace(
      '+',
      '',
    );
    setIsLoading(true);
    let fromEmail = '';
    let contactNum = '';
    let companyName = '';
    if (!isEmpty(userDetails)) {
      fromEmail = userDetails.ContactEmail;
      contactNum = userDetails.ContactNumber;
      companyName = userDetails.Company;
    }
    let msg = '';
    const airplaneEmoji = '✈️';
    selectedFlights.forEach((flt, fltIndex) => {
      msg += 'Onward Journey --->\n';
      flt.onwardFlight.flightlegs.forEach((leg, index) => {
        msg += `${index === 0 ? fltIndex + 1 : ''} ${
          index === 0 ? airplaneEmoji : ''
        } ${leg.validatingcarriername} ${leg.carrier.substring(0, 2)} - ${
          leg.flightnumber
        } | ${leg.origin_name} - ${formatDate(
          getNewDate(leg.depdate),
          DATE_MONTH_YEAR_VIEW_FORMAT,
        )} ${formatTimeString(leg.deptime)} --> ${
          leg.destination_name
        } - ${formatDate(
          getNewDate(leg.arrdate),
          DATE_MONTH_YEAR_VIEW_FORMAT,
        )} ${formatTimeString(leg.arrtime)} \n`;
        msg += `Cabin Baggage: 7Kg \nCheckin Baggage: ${getCabinBaggage(
          flt.fare.flightBagWeight[index],
          flt.fare.flightBagUnit[index],
        )} \n`;
        if (
          leg.destination !==
          flt.onwardFlight.flightlegs[flt.onwardFlight.flightlegs.length - 1]
            .destination
        ) {
          msg += `-------- ${getConnectingTime(
            leg.arrtime,
            leg.arrdate,
            flt.onwardFlight.flightlegs[index + 1].deptime,
            flt.onwardFlight.flightlegs[index + 1].depdate,
          )} layover in ${leg.destination_name} -------\n`;
        }
      });
      msg += `Onward Stops : ${
        flt.onwardFlight.numstops !== 0 ? flt.onwardFlight.numstops : 'Non'
      } Stop\n`;
      msg += 'Return Journey --->\n';
      flt.returnFlight.flightlegs.forEach((leg, lgrtindex) => {
        msg += `${lgrtindex === 0 ? fltIndex + 1 : ''} ${
          lgrtindex === 0 ? airplaneEmoji : ''
        } ${leg.validatingcarriername} ${leg.carrier.substring(0, 2)} - ${
          leg.flightnumber
        } | ${leg.origin_name} - ${formatDate(
          getNewDate(leg.depdate),
          DATE_MONTH_YEAR_VIEW_FORMAT,
        )} ${formatTimeString(leg.deptime)} --> ${
          leg.destination_name
        } - ${formatDate(
          getNewDate(leg.arrdate),
          DATE_MONTH_YEAR_VIEW_FORMAT,
        )} ${formatTimeString(leg.arrtime)} \n`;
        msg += `Cabin Baggage: 7Kg \nCheckin Baggage: ${getCabinBaggage(
          flt.fare.flightBagWeightReturn[lgrtindex],
          flt.fare.flightBagUnitReturn[lgrtindex],
        )} \n`;
        if (
          leg.destination !==
          flt.returnFlight.flightlegs[flt.returnFlight.flightlegs.length - 1]
            .destination
        ) {
          msg += `-------- ${getConnectingTime(
            leg.arrtime,
            leg.arrdate,
            flt.returnFlight.flightlegs[lgrtindex + 1].deptime,
            flt.returnFlight.flightlegs[lgrtindex + 1].depdate,
          )} layover in ${leg.destination_name} -------\n`;
        }
      });
      msg += `Return Stops : ${
        flt.returnFlight.flightlegs.length > 1
          ? flt.returnFlight.flightlegs.length - 1
          : 'Non'
      } Stop\n`;
      msg += `\nCabin Type : ${PREF_CLASS_OPTIONS[searchRequest.prefclass]}\n`;
      if (showBreakup) {
        msg += `${flt.fare.faretype} Fare : ${
          appConfig?.appCurrency
        } ${getAmount(selectedFares[fltIndex])}\n`;
      }
      msg += '\n<------------------------------------------>\n';
    });
    msg += `👇🏻👇🏻👇🏻👇🏻👇🏻👇🏻👇🏻👇🏻👇🏻👇🏻👇🏻👇🏻👇🏻\n\nThank you for choosing ${companyName}\nIn case of any urgent support : \n`;
    msg += `☎ Contact : ${contactNum}\n✉ Email : ${fromEmail}\n`;
    onSend(numberWithCountryCode, msg);
    setIsLoading(false);
  };

  const handleAddMarkup = (val) => {
    setMarkupToBeAdded(val);
  };

  return (
    <div>
      <AppLoading isLoading={isLoading} />
      <div className="fs-14">
        <div className="d-flex align-items-center gap-3 mb-1">
          <AppRadioInput
            id="true"
            name="showBrakup"
            labelText="With Fare"
            value=""
            onChange={() => setShowBreakup(true)}
            checked={showBreakup}
          />
          <AppRadioInput
            id="false"
            name="showBrakup"
            labelText="Without Fare"
            value=""
            onChange={() => setShowBreakup(false)}
            checked={!showBreakup}
          />
        </div>
        <Row className="mt-3 spacing-8 gapbetween">
          <Col lg={2} md={2} sm={6} xs={4}>
            <AppSelect
              className="country-codes-input"
              name="countryCode"
              id="countryCode"
              label="Country code"
              placeholder=""
              required
              selectedValue={countryCode}
              options={countryCodeOptions}
              isClearable={false}
              errorText={validationError && 'Please select country code'}
              onSelect={(value) =>
                value !== null
                  ? setCountryCode(value.value)
                  : setCountryCode('')
              }
            />
          </Col>
          <Col lg={5} md={5} sm={12} xs={12}>
            <AppNumberInput
              name="whatsappNumber"
              label="Enter Mobile Number"
              required
              placeholderText="Enter Customer No"
              value={whatsappNumber}
              onChange={(value) => setWhatsappNumber(value)}
              errorText={validationError && 'Please Enter Mobile Number'}
            />
            {checkValidMobileNumber(whatsappNumber) && validationError && (
              <small className="app-error-text">Enter Valid Number</small>
            )}
          </Col>
          <Col lg={5} md={6} sm={6} xs={12}>
            <AppNumberInput
              name="markUpToBeAdded"
              label="Markup"
              value={markUpToBeAdded}
              onChange={(d) => handleAddMarkup(d)}
            />
          </Col>
        </Row>
      </div>
      <div className="d-flex justify-content-center align-items-center hide-in-mobile">
        <div
          className="overflow-auto"
          style={{ height: '300px', width: '750px', padding: '1rem' }}
        >
          <div className="border">
            {selectedFlights.map((selectedFlight, index) => (
              <RoundTripIntlEmailCard
                key={selectedFlight.fare.nextraflightkey}
                onwardFlight={selectedFlight.onwardFlight}
                returnFlight={selectedFlight.returnFlight}
                isLast={index === selectedFlights.length - 1}
                showHideFare={showBreakup}
                fare={selectedFlight.fare}
                searchRequest={searchRequest}
                index={index}
                markUpToBeAdded={markUpToBeAdded}
                showInput
                onFareUpdate={() => {}}
              />
            ))}
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-end my-2">
        <AppButton
          variant="primary"
          onClick={handleSend}
          btnText="Share in Whatsapp"
        />
      </div>
    </div>
  );
}

RoundTripIntlWhatsAppModal.propTypes = {
  searchRequest: PropTypes.object.isRequired,
  selectedFlights: PropTypes.array.isRequired,
  onSend: PropTypes.func.isRequired,
};

export default RoundTripIntlWhatsAppModal;
